<div #signature id="signature">
  <div *ngIf="isLoadingCreditorProposal || isLoadingAccord" class="d-flex justify-content-center align-items-center">
    <mat-spinner diameter="30" color="primary"></mat-spinner>
  </div>
  <app-html-shadow-dom [hidden]="isLoadingCreditorProposal" [unsafeHtml]="creditorProposalDocumentHtml"></app-html-shadow-dom>
  <app-html-shadow-dom [hidden]="isLoadingAccord" [unsafeHtml]="creditorAccordDocumentHtml"></app-html-shadow-dom>
</div>
